import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import React, {useEffect, useState} from "react"
import { Row, Col, Alert, Card, CardBody, Container } from "reactstrap"

// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// action
import { userResetPassword, userChangePassword } from "../../store/actions"

// import images
import logoSm from "../../assets/images/logo-sm.png";

const ResetPasswordPage = props => {
  const searchParams = new URLSearchParams(location.search);
  const username = searchParams.get('username');
  const token = searchParams.get('token');
  const email = searchParams.get('email');

  const stateReset = token !== '' && token !== undefined && token !== null;

  const [oldPass, setOldPass] = useState('');
  const [newPass, setNewPass] = useState('');

  useEffect(() => {
    // go to login page
    if(props.resetError !== null) {
      setTimeout(() => {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        props.history.push(`/login?username=${obj.username}`);
      }, 1000)
    } else {
      if (stateReset) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        props.history.push(`/login?username=${obj.username}`);
      } else if (props.resetSuccessMsg !== null && props.resetSuccessMsg !== ''){
        props.history.push('/profile');
      }
    }
  }, [props.resetSuccessMsg, props.resetError]);

  function handleValidSubmit(event, values) {
    values.token = token;
    props.userResetPassword(values, props.history)
  }

  function changePassword(event, values) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    values.id = obj.uid;
    props.userChangePassword(values);
  }

  function gotoBack(ev) {
    props.history.goBack();
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>Reset Password | FlyingCarpet Marketer Admin Dashboard</title>
      </MetaTags>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={4}>
              <Card className="overflow-hidden">
                <div className="bg-primary">
                  <div className="text-primary text-center p-4">
                    <h5 className="text-white font-size-20 p-2">Reset Password</h5>
                    <a href="index.html" className="logo logo-admin">
                      <img src={logoSm} height="24" alt="logo" />
                    </a>
                  </div>
                </div>
                <CardBody className="p-4">

                  {props.resetError ? (
                    <Alert color="danger" style={{ marginTop: "13px" }} className="mt-5">
                      {props.resetError}
                    </Alert>
                  ) : null}
                  {props.resetSuccessMsg ? (
                    <Alert color="success" style={{ marginTop: "13px" }} className="mt-5">
                      {props.resetSuccessMsg}
                    </Alert>
                  ) : null}

                  {stateReset ?
                    (<AvForm
                      className="form-horizontal mt-4"
                      onValidSubmit={(e, v) => handleValidSubmit(e, v)}
                    >
                      <div className="mb-3">
                        <AvField
                          id="email"
                          name="email"
                          label="Email"
                          value={email}
                          placeholder="Enter email"
                          type="email"
                          disabled={true}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <AvField
                          name="username"
                          label="Username"
                          type="text"
                          placeholder="Enter username"
                          value={username}
                          disabled={true}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <AvField
                          name="password"
                          label="Password"
                          type="password"
                          validate={{
                            required: { value: true, errorMessage: 'Password is required' },
                            minLength: { value: 8, errorMessage: 'Password must be at least 8 characters' },
                            pattern: {
                              value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9])/,
                              errorMessage:
                                'Passwords must have at least one non-alphanumeric character, one digit, and one uppercase letter',
                            },
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <AvField
                          name="confirmPassword"
                          label="Confirm Password"
                          type="password"
                          validate={{
                            required: { value: true, errorMessage: 'Confirm Password is required' },
                            match: { value: 'password', errorMessage: 'Passwords do not match' }
                          }}
                        />
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                            disabled={props.loading}
                          >
                            Submit
                          </button>
                        </Col>
                      </Row>
                    </AvForm>)
                    :
                    (<AvForm
                      className="form-horizontal mt-4"
                      onValidSubmit={(e, v) => changePassword(e, v)}
                    >
                      <div className="mb-3">
                        <AvField
                          name="oldPassword"
                          label="Old Password"
                          type="text"
                          placeholder="Enter old password"
                          required
                          value={oldPass}
                        />
                      </div>
                      <div className="mb-3">
                        <AvField
                          name="newPassword"
                          label="New password"
                          type="password"
                          validate={{
                            required: { value: true, errorMessage: 'Password is required' },
                            minLength: { value: 8, errorMessage: 'Password must be at least 8 characters' },
                            pattern: {
                              value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9])/,
                              errorMessage:
                                'Passwords must have at least one non-alphanumeric character, one digit, and one uppercase letter',
                            },
                          }}
                          value={newPass}
                        />
                      </div>
                      <div className="mb-3">
                        <AvField
                          name="confirmPassword"
                          label="Confirm Password"
                          type="password"
                          validate={{
                            required: { value: true, errorMessage: 'Confirm Password is required' },
                            match: { value: 'newPassword', errorMessage: 'Passwords do not match' }
                          }}
                        />
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                            disabled={props.loading}
                          >
                            Submit
                          </button>
                          {!stateReset && <button
                            className="btn btn-primary w-md waves-effect waves-light mx-2"
                            disabled={props.loading}
                            onClick={gotoBack}
                          >
                            Cancel
                          </button>}
                        </Col>
                      </Row>
                    </AvForm>)
                  }

                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>Remember It ? <Link to="login" className="fw-medium text-primary"> Sign In here </Link> </p>
                <p>
                  © {new Date().getFullYear()} FlyingCarpet{" "}
                  <i className="mdi mdi-heart text-danger" />
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ResetPasswordPage.propTypes = {
  resetError: PropTypes.any,
  resetSuccessMsg: PropTypes.any,
  history: PropTypes.object,
  userResetPassword: PropTypes.func,
  userChangePassword: PropTypes.func
}

const mapStatetoProps = state => {
  const { resetError, resetSuccessMsg, loading } = state.ResetPassword
  return { resetError, resetSuccessMsg, loading }
}

export default withRouter(
  connect(mapStatetoProps, { userResetPassword, userChangePassword })(ResetPasswordPage)
)
